import { createDecorator } from '../../instantiation/common/instantiation.js';
const IBuiltinExtensionsScannerService = ( createDecorator('IBuiltinExtensionsScannerService'));
export { IBuiltinExtensionsScannerService };
